export default async function sendFormData(e, form, method) {
  let resp = await fetch(form.action, {
    method: method || "post",
    body: new FormData(form),
  });
  return resp;
}
